<ng-template [ngIf]="hasSlider">
  <div class="list-card">
    <div class="list-card__slider">
      <lib-list-card-slider
        [images]="data.images"
        (clicked)="onLinkClick()"
        [canSlide]="true"
        [carousel]="true"
      ></lib-list-card-slider>
    </div>

    <a class="list-card__main" [href]="detailPageUrl" (click)="onLinkClick()">
      <p class="list-card__location">
        <lib-location-display [location]="data.location"></lib-location-display>
      </p>

      <h3 class="list-card__title">
        {{ title }}
      </h3>

      <p class="list-card__description">
        <ng-container *ngIf="data.status !== 'sold'">
          {{ data.description }}
        </ng-container>
      </p>

      <span class="list-card__chips">
        <span
          class="list-card__chip"
          *ngIf="data.floorSpace || data.usageSpace || data.propertySpace"
        >
          <lib-chip>
            {{ data.floorSpace || data.usageSpace || data.propertySpace }} m<sup
              >2</sup
            >
          </lib-chip>
        </span>

        <span
          class="list-card__chip"
          *ngIf="data.roomCount && data.category !== 'income'"
        >
          <lib-chip>
            {{ data.roomCount }} {{ 'filters.roomCount.label' | i18n }}
          </lib-chip>
        </span>

        <span
          class="list-card__chip"
          *ngIf="data.flats && data.category === 'income' && !data.rateOfReturn"
        >
          <lib-chip>
            {{ data.flats + data.offices }} {{ 'filters.units.label' | i18n }}
          </lib-chip>
        </span>

        <span
          class="list-card__chip"
          *ngIf="data.rateOfReturn && data.category === 'income'"
        >
          <lib-chip>
            {{ data.rateOfReturn }}% {{ 'filters.rateOfReturn.label' | i18n }}
          </lib-chip>
        </span>

        <span class="list-card__chip" *ngIf="price">
          <lib-chip>
            <ng-container *ngIf="price; else priceOnRequest">
              <span [innerHTML]="price"></span>
            </ng-container>
            <ng-template #priceOnRequest>
              {{ 'realEstateObject.priceOnRequest' | i18n }}
            </ng-template>
          </lib-chip>
        </span>
      </span>
    </a>
    <div class="list-card-flags">
      <lib-list-card-flag type="reserved" *ngIf="data.status === 'reserved'">
        {{ 'realEstateObject.reserved' | i18n }}
      </lib-list-card-flag>

      <lib-list-card-flag type="top" *ngIf="data.topOffer">
        {{ 'realEstateObject.topOffer' | i18n }}
      </lib-list-card-flag>

      <lib-list-card-flag type="3d-tour" *ngIf="data.hasVirtualTour">
        {{ 'realEstateObject.virtualTour' | i18n }}
      </lib-list-card-flag>
    </div>
  </div>
</ng-template>

<ng-template [ngIf]="!hasSlider">
  <ng-template [ngIf]="data.status === 'sold'">
    <div class="list-card" (click)="onLinkClick()">
      <div class="list-card__slider">
        <lib-list-card-slider
          [images]="data.images"
          (clicked)="onLinkClick()"
          [canSlide]="false"
        ></lib-list-card-slider>
      </div>

      <div class="list-card__main">
        <p class="list-card__location">
          <lib-location-display
            [location]="data.location"
          ></lib-location-display>
        </p>

        <h3 class="list-card__title">
          {{ title }}
        </h3>

        <!-- keep empty description to preserve layout -->
        <p class="list-card__description"></p>

        <span class="list-card__chips">
          <span
            class="list-card__chip"
            *ngIf="data.floorSpace || data.usageSpace || data.propertySpace"
          >
            <lib-chip>
              {{ data.floorSpace || data.usageSpace || data.propertySpace }}
              m<sup>2</sup>
            </lib-chip>
          </span>
          <span
            class="list-card__chip"
            *ngIf="data.roomCount && data.category !== 'income'"
          >
            <lib-chip>
              {{ data.roomCount }} {{ 'filters.roomCount.label' | i18n }}
            </lib-chip>
          </span>
          <span
            class="list-card__chip"
            *ngIf="data.flats && data.category === 'income'"
          >
            <lib-chip>
              {{ data.flats + data.offices }} {{ 'filters.units.label' | i18n }}
            </lib-chip>
          </span>
        </span>
      </div>
      <div class="list-card-flags">
        <lib-list-card-flag type="reserved"
          >{{ 'realEstateObject.sold' | i18n }}
        </lib-list-card-flag>
      </div>
    </div>
  </ng-template>

  <ng-template [ngIf]="data.status !== 'sold'">
    <a class="list-card" [href]="detailPageUrl" (click)="onLinkClick()">
      <span class="list-card__slider">
        <lib-list-card-slider
          [images]="data.images"
          (clicked)="onLinkClick()"
          [canSlide]="false"
        ></lib-list-card-slider>
      </span>

      <div class="list-card__main">
        <p class="list-card__location">
          <lib-location-display
            [location]="data.location"
          ></lib-location-display>
        </p>

        <h3 class="list-card__title">
          {{ title }}
        </h3>

        <p class="list-card__description">
          {{ data.description }}
        </p>

        <span class="list-card__chips">
          <span
            class="list-card__chip"
            *ngIf="data.floorSpace || data.usageSpace || data.propertySpace"
          >
            <lib-chip>
              {{ data.floorSpace || data.usageSpace || data.propertySpace }}
              m<sup>2</sup>
            </lib-chip>
          </span>
          <span
            class="list-card__chip"
            *ngIf="data.roomCount && data.category !== 'income'"
          >
            <lib-chip>
              {{ data.roomCount }} {{ 'filters.roomCount.label' | i18n }}
            </lib-chip>
          </span>
          <span
            class="list-card__chip"
            *ngIf="
              data.flats && data.category === 'income' && !data.rateOfReturn
            "
          >
            <lib-chip>
              {{ data.flats + data.offices }} {{ 'filters.units.label' | i18n }}
            </lib-chip>
          </span>
          <span class="list-card__chip" *ngIf="data.rateOfReturn">
            <lib-chip>
              {{ data.rateOfReturn }}% {{ 'filters.rateOfReturn.label' | i18n }}
            </lib-chip>
          </span>
          <span class="list-card__chip" *ngIf="price">
            <lib-chip>
              <ng-container *ngIf="price; else priceOnRequest">
                {{ price }}
              </ng-container>
              <ng-template #priceOnRequest>
                {{ 'realEstateObject.priceOnRequest' | i18n }}
              </ng-template>
            </lib-chip>
          </span>
        </span>
      </div>
      <div class="list-card-flags">
        <lib-list-card-flag type="reserved" *ngIf="data.status === 'reserved'"
          >{{ 'realEstateObject.reserved' | i18n }}
        </lib-list-card-flag>
        <lib-list-card-flag type="top" *ngIf="data.topOffer"
          >{{ 'realEstateObject.topOffer' | i18n }}
        </lib-list-card-flag>
        <lib-list-card-flag type="3d-tour" *ngIf="data.hasVirtualTour"
          >{{ 'realEstateObject.virtualTour' | i18n }}
        </lib-list-card-flag>
      </div>
    </a>
  </ng-template>
</ng-template>
